import { render, staticRenderFns } from "./QuickAppUserAgreement.vue?vue&type=template&id=0aeb5b76&scoped=true"
import script from "./QuickAppUserAgreement.vue?vue&type=script&lang=js"
export * from "./QuickAppUserAgreement.vue?vue&type=script&lang=js"
import style0 from "./QuickAppUserAgreement.vue?vue&type=style&index=0&id=0aeb5b76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aeb5b76",
  null
  
)

export default component.exports